import { Modal } from '@integration/alexandria-ui';
import { FunctionComponent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from 'redux/actions/modalActions';
import { modalConfigSelector } from 'redux/selectors/modal';

/**
 * Intended to be used with Redux's state
 */
const ModalV2: FunctionComponent = () => {
  const dispatch = useDispatch();
  const {
    content: Content,
    onClose,
    show,
    showCloseIcon,
  } = useSelector(modalConfigSelector);

  const handleClose = () => {
    onClose?.();
    dispatch(actions.hideModalV2());
  };

  return (
    <Modal show={show} showCloseIcon={showCloseIcon} onClose={handleClose}>
      {Content ? <Content /> : <></>}
    </Modal>
  );
};

export default ModalV2;
